import React from "react";
import ReactDom from "react-dom";
import SearchWrapper from "./components/Search";
import Checkout from "./components/Checkout";
import MetaSearchCheckout from "./components/MetaSearchCheckout";
import RecoverPassword from "./components/RecoverPassword";
import NewPassword from "./components/NewPassword";
import PriceAlertDisable from "./components/PriceAlertDisable";
import PriceAlertRedirect from "./components/priceAlert/PriceAlertRedirect";
import MaxAirBridge from "./components/MaxAirBridge";
import thunkMiddleware from "redux-thunk";

import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";

import { createBrowserHistory as createHistory } from "history";
import { Route, Switch, browserHistory } from "react-router";

import { ConnectedRouter, routerMiddleware } from "react-router-redux";
import { defineLocale, $ } from "./shared/utils";
import { getSearchFlightParams, hideHeaderSearch, checkIfIsLogout } from "./shared/routes-trigger";
import reducers from "./reducers";
import { IS_HMG, IS_PROD, IS_DEV } from "./shared/constants";
import MyTripsLight from "./components/account/MyTripsLight";
import CancellationWrapper from "./components/account/cancellation/CancellationWrapper";
import RebookingWrapper from "./components/account/rebooking/RebookingWrapper";
import DetailsWrapper from "./components/account/details/DetailsWrapper";

import { AffiliateProgram } from "@maxmilhas/hangar-components-lps";

export const history = createHistory();
const middleware = routerMiddleware(history);
export let store;

if (IS_DEV || IS_HMG) {
	const composeEnhancers =
		typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
			? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
			: compose;

	const enhancer = composeEnhancers(applyMiddleware(middleware, thunkMiddleware));

	store = createStore(reducers, enhancer);
} else if (IS_PROD) {
	store = createStore(reducers, applyMiddleware(middleware, thunkMiddleware));
}

if (
	window.location.href.match("about:blank") == null &&
	window.location.href !== "http://localhost/"
) {
	/**
	 * a suíte de testes roda nesse endereço(about:blank).
	 * Quando importamos {store} e {history}, eles tentavam executar history.push() indevidamente,
	 * o que resultava em quebra dos testes.
	 * O if acima evita que o ambiente de testes execute um history.push indevido.
	 */

	history.push(window.location.pathname + window.location.search);

	if ($("#loader_wrapper")) {
		$("#loader_wrapper").classList.add("visualHidden");

		setTimeout(() => {
			$("#loader_wrapper").classList.add("hidden");
		}, 900);
	}

	getSearchFlightParams(window.location);
	hideHeaderSearch();
	checkIfIsLogout();
	defineLocale();

	history.listen(ev => {
		getSearchFlightParams(window.location);
		hideHeaderSearch();
		checkIfIsLogout();
		window.scrollTo(0, 0);
	});
	ReactDom.render(
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<div>
					<Switch>
						<Route path="/busca-passagens-aereas/(RT|OW)" component={SearchWrapper} />
						<Route path="/busca-passagens-aereas/checkout" component={Checkout} />
						<Route path="/comprar" component={MetaSearchCheckout} />
						<Route path="/relembrar-senha" component={RecoverPassword} />
						<Route path="/nova-senha/:token" component={NewPassword} />
						<Route path="/alerta-de-preco/descadastrar/:id" component={PriceAlertDisable} />
						<Route path="/alerta-de-preco/comprar/:id" component={PriceAlertRedirect} />
						<Route
							path="/cliente/minhas-viagens-light/cancelamento"
							component={CancellationWrapper}
						/>
						<Route
							path="/cliente/minhas-viagens-light/remarcacao"
							component={RebookingWrapper}
						/>
						<Route
							path="/cliente/minhas-viagens-light/detalhes"
							component={DetailsWrapper}
						/>
						<Route path="/cliente/minhas-viagens-light" component={MyTripsLight} />
						<Route path="/programa-de-afiliados" component={AffiliateProgram} />
						<Route path="/ponte-aerea-max" component={MaxAirBridge} />
					</Switch>
				</div>
			</ConnectedRouter>
		</Provider>,
		document.getElementById("root")
	);
}
